import React from "react";
import Card from "./card";
import Grid from "@material-ui/core/Grid";
import {
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
    },
  },
});
theme.spacing(3);

const CardQueue = (props) => {
  const makeGrid = () => {
    if (typeof props.queue !== "undefined") {
      return props.queue.map((card, index) => (
        <Card
          front={card.card_text.slice(0, 116)}
          back={card.hover_text} //.slice(0, 147)
          bgcolor={card.background_color}
          link={card.link === "undefined" ? null : card.link}
          image={card.image}
          key={index}
          xs={12}
          sm={6}
          md={4}
          lg={3}
        />
      ));
    } else return null;
  };

  //console.log("CardQueue =>", props.queue);
  return (
    <div style={{
      marginLeft: "20px",
      marginRight: "20px",
      paddingBottom: "16px",
    }}>
      <ThemeProvider theme={theme}>
        <Grid container>
          <Grid item xs={12}>
            <Grid
              container
              spacing={3}
              style={{
                maxWidth: "1200px",
                flexGrow: "1",
                boxSizing: "border-box",
              }}
            >
              {makeGrid()}
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>
    </div>
  );
};

export default CardQueue;
